export default [
  {
    path: '/login',
    name: 'login',
    component() {
      return import(/* webpackChunkName: "login" */ '../views/Login.vue');
    },
    meta: { noLayout: true },
  },
  {
    path: '/',
    alias: '/dashboard',
    name: 'dashboard',
    component() {
      return import(/* webpackChunkName: "dashboard" */ '../modules/dashboard');
    },
  },
  {
    // @todo add a prefix like `main/:action/:a?/:b?/:c?` to seperate other routes
    // This regex for only route mathing, other logics are running in matched components
    path: '/:action/:a?/:b?/:c?',
    name: 'mainView',
    component() {
      return import(/* webpackChunkName: "mainView" */ '../modules/mainView/index.vue');
    },
  },
];
